// Re-export generated types and schemas
export * from './generated/api-client';

// Re-export client
export * from './client';

// Shared request-body sanitizer (cycle-safe + Firestore-ref strip)
export { sanitizeRequestBody } from './sanitize';
